module.exports = __webpack_public_path__ + "static/videos/explanation-1.97c79ce.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/explanation-1.mp4
// module id = CX43
// module chunks = 1